import './floatingChrome.css';

// PROTOTYPE, THE CHROME AFLOAT (owner call 2026-10-22): ?float=1 turns it on and keeps it on in this browser, ?float=0
// turns it off. A prototype to look at, not the app: nothing else reads it.
const KEY = 'caliber:proto-float';
const asked = new URLSearchParams(location.search).get('float');
try { if (asked === '1') localStorage.setItem(KEY, '1'); else if (asked === '0') localStorage.removeItem(KEY); } catch { /* private window */ }
let on = asked === '1';
try { on = on || localStorage.getItem(KEY) === '1'; } catch { /* private window */ }
document.documentElement.toggleAttribute('data-float-proto', on);
